import Markdown, { type Components } from "react-markdown";
import remarkBreaks from "remark-breaks";

interface BotMessageProps {
  message: string;
}

const componentContainer = "flex flex-col justify-center items-start gap-2.5 self-stretch mr-4.5";
const messageContainer =
  "flex w-full p-3 flex-col justify-end items-start gap-2.5 rounded-md rounded-tl-none bg-loch-50";
const textStyles = "text-slate text-small-body-md tracking-normal";

const markdownComponents: Components = {
  p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
  a: ({ href, children }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-loch visited:text-loch-700 hover:underline transition-colors"
    >
      {children}
    </a>
  ),
  strong: ({ children }) => <strong className="font-bold">{children}</strong>,
  em: ({ children }) => <em className="italic">{children}</em>,
  ul: ({ children }) => <ul className="list-disc pl-4 mb-2 last:mb-0">{children}</ul>,
  li: ({ children }) => <li className="mb-0.5">{children}</li>,
};

export const PropertyPalBotMessage = (props: BotMessageProps) => {
  return (
    <div className={componentContainer}>
      <div className={messageContainer}>
        <div className={textStyles}>
          <Markdown remarkPlugins={[remarkBreaks]} components={markdownComponents}>
            {props.message}
          </Markdown>
        </div>
      </div>
    </div>
  );
};
